import BasicButton from "@components/core/buttons/BasicButton";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";
import { Input } from "antd";
import parse from "html-react-parser";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

interface FinalizationCauseModalProps extends Omit<BasicModalProps, "onOk"> {
  onOk: (cause: string) => void;
}

const FinalizationCauseModal: FunctionComponent<
  FinalizationCauseModalProps
> = ({ onOk, ...props }) => {
  const { t } = useTranslation();

  const [finalizationCause, setFinalizationCause] = useState<string>("");

  return (
    <BasicModal
      {...props}
      onOk={() => onOk(finalizationCause)}
      closable={false}
      footer={
        <div className="modal-footer-buttons">
          <BasicButton
            variant="secondary"
            text={t("buttons.cancel")}
            onClick={props.onCancel}
          />
          <BasicButton
            variant="primary"
            text={t("buttons.validate")}
            onClick={() => onOk(finalizationCause)}
          />
        </div>
      }
      className={`app-modal-action-cause ${props.className}`}
    >
      <div className="px-15">
        <p>{parse(t("modal.finalization.description"))}</p>
        <label htmlFor="motif">{t("modal.reason")}</label>
        <Input.TextArea
          id="motif"
          value={finalizationCause}
          onChange={(e) => setFinalizationCause(e.target.value)}
          maxLength={255}
          autoSize={{ minRows: 6, maxRows: 6 }}
        />
      </div>
    </BasicModal>
  );
};

export default FinalizationCauseModal;
